import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
const { user } = API;
const { queryDealerPage, getAllGroupName, } = user;
const initState = {
    tableTotal: 0,
    pageSize: 20,
    pageIndex: 1,
    TableData: [],
    searchData: {},
    allGroupName: [],
    loading: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        updateTable({ page }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { searchData, pageIndex, pageSize } = state;
                if (searchData.time) {
                    searchData.dateFrom = searchData.time[0];
                    searchData.dateTo = searchData.time[1];
                    delete searchData.time;
                }
                const searchParams = Object.assign(Object.assign({}, searchData), { pageIndex: page || pageIndex, pageSize });
                this.SET_STATE({
                    loading: true,
                });
                queryDealerPage(searchParams).then((res) => {
                    // console.log(res);
                    const { items, totalNumber } = res;
                    this.SET_STATE({
                        TableData: items,
                        tableTotal: totalNumber,
                        pageIndex: page || pageIndex,
                    });
                }).finally(() => {
                    this.SET_STATE({
                        loading: false,
                    });
                });
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign({}, initState));
        },
        getGroupName() {
            getAllGroupName().then((res) => {
                // console.log(res)
                this.SET_STATE({
                    allGroupName: res,
                });
            });
        },
        changeAsyncState(changeData) {
            API.user.changeAsyncState(Object.assign({}, changeData))
                .then(() => {
                this.updateTable({});
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
